/* eslint-disable func-names */
/* eslint-disable no-console */
import { takeEvery } from 'redux-saga/effects';
import createSagaMiddleware from 'redux-saga';
import { configureStore } from '@reduxjs/toolkit';
import rootReducer from '../reducers';
import userSaga from './user';
import apiKeySaga from './apiKey';
import balancesSaga from './balances';
import transactionsSaga from './transactions';
import recipientsSaga from './recipients';
import crossBorderSaga from './crossBorder';
import configSaga from './config';
import exchangeRateSaga from './exchangeRate';

function createWatcher(actionSagaPair) {
  // eslint-disable-next-line func-names
  return function* () {
    yield takeEvery(...actionSagaPair);
  };
}

const createStore = () => {
  const sagaMiddleware = createSagaMiddleware();

  const rootSaga = [
    ...userSaga,
    ...apiKeySaga,
    ...balancesSaga,
    ...transactionsSaga,
    ...recipientsSaga,
    ...crossBorderSaga,
    ...configSaga,
    ...exchangeRateSaga,
  ].map(createWatcher);

  const store = configureStore({
    reducer: rootReducer,
    middleware: [sagaMiddleware],
  });

  rootSaga.forEach((saga) => {
    sagaMiddleware.run(saga);
  });

  return store;
};

export default createStore;
